//import Libraries
import React from 'react';

//import Components
import DepartmentModule from '../../components/DepartmentModule/DepartmentModule';

//import Style classes


const product = (props) => {

    return (
        <DepartmentModule 
        page={props.match.params.page}
        type="products"/>
    )
}

export default product;


// WEBPACK FOOTER //
// ./src/pages/Product/Product.js